/** Roles tab and the role editor (custom role names and descriptions are the merchant's own text, never translated). */
export const roles = {
  noRoles: "No roles",
  colRole: "Role",
  colType: "Type",
  colMembers: "Members",
  colCanDo: "Can do",
  colActions: "Actions",
  builtIn: "Built-in",
  custom: "Custom",
  view: "View",
  /** Button: start a new role from this one. */
  duplicate: "Copy",
  listSep: ", ",
  intro: "Built-in roles can't be changed; copy one to start a custom role. People can only grant permissions they have themselves.",
  caption: "Roles",
  saved: "Role \"{name}\" saved",
  created: "Role \"{name}\" created",
  deleteTitle: "Delete the role \"{name}\"?",
  deleteDesc: "Only possible when nobody (and no open invite) uses it.",
  deleteRole: "Delete role",
  deleted: "Role deleted",

  // Editor
  copyName: "{name} (copy)",
  nameRequired: "Give the role a name.",
  pickPermission: "Pick at least one permission.",
  codeRequired: "Enter the 6-digit code from your authenticator app.",
  codeFailed: "That code didn't work. Wait for the next code and try again.",
  role: "Role",
  editTitle: "Edit role \"{name}\"",
  copyTitle: "Copy \"{name}\"",
  newRole: "New role",
  builtInDesc: "Built-in role. Copy it to make a custom version.",
  readOnlyDesc: "You can't change this role.",
  editDesc: "Pick what people with this role can do on each page.",
  name: "Name",
  description: "Description",
  permissions: "Permissions",
  notMine: "{help} (you don't have this permission yourself, so the server will refuse to grant it)",
  saveRole: "Save role",
  createRole: "Create role",
};
